module.exports = "/images/sala_viajero_z04.jpg?dda8d1bfd0742dc8f803431793b76d21";